import { combineReducers } from 'redux';
import QuizReducer from './quiz.reducer';
import TagReducer from './tags.reducer';
import ExamTagReducer from './examtags.reducer';
import UserReducer from './user.reducer';
import AppReducer from './app.reducer';
import AuthReducer from './auth.reducer';
import StateReducer from './state.reducer';
import StatsReducer from './stats.reducer';
import FilteredReducer from './filtered.reducer';
import OptionStatsReducer from './optionStats.reducer';

const rootReducer = combineReducers({
  state: (state = {}) => state,
  app: AppReducer,
  quiz: QuizReducer,
  tags: TagReducer,
  examTags: ExamTagReducer,
  user: UserReducer,
  currentState: StateReducer,
  stats: StatsReducer,
  filtered: FilteredReducer,
  optionStats: OptionStatsReducer,
  auth: AuthReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js